// @ts-nocheck - Disable TypeScript checking for this file
import { defineNuxtPlugin } from 'nuxt/app'
import * as entities from 'entities'

// Create a shim for the entities/lib/esm/decode.js module
// This helps prevent the "does not provide an export named 'default'" error
if (typeof window !== 'undefined') {
  // Only run in client context
  try {
    // Dynamically create the module
    window.__modules = window.__modules || {}
    // Add the decode module to the modules cache
    window.__modules['entities/lib/esm/decode.js'] = {
      // Provide all the exports that might be expected
      decodeXML: entities.decodeXML,
      decodeHTML: entities.decodeHTML,
      decodeHTMLStrict: entities.decodeHTMLStrict,
      decodeHTMLAttribute: entities.decodeHTMLAttribute,
      DecodingMode: { Legacy: 0, Strict: 1, Attribute: 2 },
      EntityDecoder: class EntityDecoder {
        // Simple stub implementation
        decode(str) { return entities.decodeHTML(str) }
      },
      // Add a default export that matches what's expected
      default: entities.decode
    }
  } catch (e) {
    console.error('Failed to create entities decode shim:', e)
  }
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      decode: entities.decode
    }
  }
})
